import {Pipe, PipeTransform} from '@angular/core';
import {Adres} from '../adres';

@Pipe({
    name: 'zahAdres',
    standalone: false
})
export class AdresPipe implements PipeTransform {
  transform(adres: Adres): string {
    // eslint-disable-next-line max-len
    return `${adres.getStraat()} ${adres.getNummer()} ${adres.getBus() ? adres.getBus() : ''} ${adres.getPostcode()} ${adres.getGemeente()}`;
  }
}
